export const REQUIRED_CREDITS = {
  GENERATE_DIALOG: 1,
  GENERATE_COMIC_IMAGE: 1,
};
